export const dataVizColorsText = [
    "#E92519", 
    "#0A8D1E",
    "#C57800",
    "#197BDE",
    "#997F00",
    "#13918C",
    "#93662D",
    "#B554E6",
]

export const dataVizColors = [
    "#7856FF",
    "#FF7557",
    "#5CC1B9",
    "#F8BC3B",
    "#B2596E",
    "#72BEF4",
    "#FFB27A",
    "#0D7EA0",
    "#3BA974",
    "#FEBBB2",
    "#CA80DC",
    "#5BB7AF"
]

export const dataVizColorsLight = [
    "#C5B7FF",
    "#FFAB99",
    "#95D8D3",
    "#FACB68",
    "#D5B0B8",
    "#95D3FF",
    "#FED1B1",
    "#7BB3C3",
    "#81D4AC",
    "#EFB8B1",
    "#DAA6E6",
    "#A4CDC9"
]